import {
  Activity, Sun, Zap, Music, Target, Wind, Heart, Smile, Users, Award, Clock,
  Star, ArrowRight, Loader2, Inbox, Dumbbell, CheckCircle2, ChevronRight,
} from "lucide-react";

// Maps backend/category Feather icon names to lucide components.
const MAP = {
  activity: Activity, sun: Sun, zap: Zap, music: Music, target: Target, wind: Wind,
  heart: Heart, smile: Smile, users: Users, award: Award, clock: Clock, star: Star,
  "arrow-right": ArrowRight, "check-circle": CheckCircle2, "bar-chart-2": Activity,
};

export function CatIcon({ name, className, size = 16 }) {
  const Cmp = MAP[name] || Dumbbell;
  return <Cmp className={className} size={size} />;
}

export { Loader2, Inbox, Dumbbell, ChevronRight, Star };
